import http from "../helpers/http";

export const getPaymentInvoice = async (code) => {
  const res = await http().get(`/PaymentInvoice/Index/${code}`);
  return res.data;
};

export const initializeTransaction = async (payload) => {
  const res = await http().post(
    "/PaymentInvoice/InitializeTransaction",
    payload
  );
  return res.data;
};

export const invoiceStatus = async (id) => {
  const res = await http().get(`/PaymentInvoice/GetPaymentStatus/${id}`);
  return res.data;
};
